function HeaderSearchQuickLinks() {
  const input = document.getElementById("header-search");
  const quickLinks = document.getElementById("header-search-quick-links");
  if (!input || !quickLinks) return;

  const options = Array.from(quickLinks.querySelectorAll("[role='option']"));
  let currentIndex = -1;
  let removeFocusTrap = null;

  const focusableSelectors =
    "a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex='-1'])";

  function trapFocus(container) {
    const focusable = Array.from(
      container.querySelectorAll(focusableSelectors),
    );
    if (!focusable.length) return () => {};

    const first = focusable[0];
    const last = focusable[focusable.length - 1];

    function onKeydown(e) {
      if (e.key === "Tab") {
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
      if (e.key === "Escape") {
        e.preventDefault();
        hideQuickLinks();
        input.focus();
      }
    }

    container.addEventListener("keydown", onKeydown);
    return () => container.removeEventListener("keydown", onKeydown);
  }

  function showQuickLinks() {
    quickLinks.classList.add("is-visible");
    input.setAttribute("aria-expanded", "true");
    removeFocusTrap?.();
    removeFocusTrap = trapFocus(quickLinks);
  }

  function hideQuickLinks() {
    quickLinks.classList.remove("is-visible");
    input.setAttribute("aria-expanded", "false");
    removeFocusTrap?.();
    removeFocusTrap = null;
    currentIndex = -1;
  }

  input.addEventListener("focus", showQuickLinks);

  input.addEventListener("blur", () => {
    setTimeout(() => {
      if (!quickLinks.contains(document.activeElement)) hideQuickLinks();
    }, 100);
  });

  input.addEventListener("keydown", (e) => {
    if (!quickLinks.classList.contains("is-visible")) return;

    if (e.key === "ArrowDown") {
      e.preventDefault();
      currentIndex = (currentIndex + 1) % options.length;
      options[currentIndex].querySelector("a").focus();
    }
  });

  options.forEach((option, index) => {
    option.addEventListener("keydown", (e) => {
      if (e.key === "ArrowDown") {
        e.preventDefault();
        currentIndex = (index + 1) % options.length;
        options[currentIndex].querySelector("a").focus();
      } else if (e.key === "ArrowUp") {
        e.preventDefault();
        currentIndex = (index - 1 + options.length) % options.length;
        options[currentIndex].querySelector("a").focus();
      } else if (e.key === "Escape") {
        e.preventDefault();
        hideQuickLinks();
        input.focus();
      }
    });

    option.addEventListener("click", () => hideQuickLinks());
  });
}

export default HeaderSearchQuickLinks;
